import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { AdviceStatus } from '@/composables/useAdvicesStatuses'

type Props = {
    status: AdviceStatus
}

export default /*#__PURE__*/_defineComponent({
  props: {
    status: { type: null, required: true }
  },
  setup(__props: any) {

const props = __props as {
    status: AdviceStatus
}


const labelColorAccordingToStatus: Record<string, string> = {
    Odrzucona: '#DB6969',
    Zweryfikowana: '#6B7280',
    Anulowana: '#6B7280',
    'Do rozliczenia': '#6B7280',
    Dostarczona: '#77BD7A',
    'Usunięta w AX': '#6B7280',
    Odmowa: '#6B7280',
    Wysłane: '#45B9ED',
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    style: _normalizeStyle({ backgroundColor: labelColorAccordingToStatus[props.status.name] }),
    class: "inline-block font-bold uppercase text-white px-2 py-1 text-xs font-basier leading-relaxed tracking-widest rounded-lg"
  }, _toDisplayString(props.status.name), 5))
}
}

})